import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LatestTerms, TermsService } from '../../services/terms.service';

@Component({
  selector: 'app-terms-of-service',
  standalone: false,
  templateUrl: './terms-of-service.component.html',
  styleUrl: './terms-of-service.component.scss',
})
export class TermsOfServiceComponent implements OnInit, OnDestroy {
  terms: LatestTerms | null = null;
  loading = false;
  error = '';

  private destroy$ = new Subject<void>();

  constructor(private termsService: TermsService) {}

  ngOnInit(): void {
    this.loadTerms();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadTerms(): void {
    this.loading = true;
    this.error = '';

    this.termsService
      .viewLatestTerms()
      .pipe(takeUntil(this.destroy$))
      .subscribe((terms) => {
        this.loading = false;
        this.terms = terms;

        if (!terms) {
          this.error = 'Terms of service could not be loaded. Please try again.';
        }
      });
  }
}
